import * as React from "react";
import classnames from "classnames";

const styles = require("./card.module.scss");

const Card: React.SFC<{ children: any; className?: string }> = ({ children, className }) => (
  <div className={classnames(className, styles.card)}>{children}</div>
);

export default Card;
